export const PermissionConstants = {
  ViewUser: "ViewUser",
  ViewManageUser: "ViewManageUser",
  ViewManageRole: "ViewManageRole",
  ViewDataPermission: "ViewDataPermission",
  EditUser: "EditUser",
  CreateBooking: "CreateBooking",
  ViewQueryDoStatus: "ViewQueryDoStatus",
  ViewQueryDo: "ViewQueryDO",
  ViewQueryDoCartonDetail: "ViewQueryDoCartonDetail",
  ViewDOOuterCaseStatus: "ViewDOOuterCaseStatus",
  ViewDoScanImport: "ViewDoScanImport",
  ViewDoSearchImport: "ViewDoSearchImport",
  ViewQueryBookingForForwarder: "ViewQueryBookingForForwarder",
  ViewQueryBookingForShipping: "ViewQueryBookingForShipping",
  BtnRePrintDocument: "BtnRePrintDocument",
  BtnTransDoScan: "BtnTransDoScan",
  BtnTransDoImport: "BtnTransDoImport",
  BtnTransOriginalDocDownload: "BtnTransOriginalDocDownload",
  BtnTransAttachUpload: "BtnTransAttachUpload",
  BtnTransAttachUploadPOD: "BtnTransAttachUploadPOD",
  BtnTransTMSReturnTransmitTMS: "BtnTransTMSReturnTransmitTMS",
  BtnTransTMSErrorTMS: "BtnTransTMSErrorTMS",
  BtnTransDHLEditDHLInfo: "BtnTransDHLEditDHLInfo",
  BtnTransDHLReturnTransmitDHL: "BtnTransDHLReturnTransmitDHL",
  BtnTransDHLDownloadDHLInvoice: "BtnTransDHLDownloadDHLInvoice",
  ViewAssignPickTask: "ViewAssignPickTask",
  BtnAssignPickTaskAssign: "BtnAssignPickTaskAssign",
  CancelBooking: "CancelBooking",
  EditBookingFormUpdatedTotalGrosswgt: "EditBookingFormUpdatedTotalGrosswgt",
  EditBookingFormUpdatedTotalCaseCnt: "EditBookingFormUpdatedTotalCaseCnt",
  EditBookingFormUpdatedTotalVolumeWeight: "EditBookingFormUpdatedTotalVolumeWeight",
  EditBookingFormExpressTerm: "EditBookingFormExpressTerm",
  BtnUrgentFlag: "BtnUrgentFlag",
  BtnRedelivery: "BtnRedelivery",
  BtnRewarehouse: "BtnRewarehouse",
  BtnDeleteBookingDetail: "BtnDeleteBookingDetail",
  BtnAssignmentDistrictMaintain: "BtnAssignmentDistrictMaintain",

  ViewUnreturnPortReport: "ViewUnreturnPortReport",
  ViewDOInvoiceReport: "ViewDOInvoiceReport",
  ViewConsignmentDailyReport: "ViewConsignmentDailyReport",

  ViewAddressMaintainSetting: "ViewAddressMaintainSetting",
  EditAddressMaintainSetting: "EditAddressMaintainSetting",
  ViewFlowDoorlaneSearch: "ViewFlowDoorlaneSearch",
  ViewWarehouseCalendar: "ViewWarehouseCalendar",
  EditWarehouseCalendar: "EditWarehouseCalendar",
  ViewLeaveWarehouse: "ViewLeaveWarehouse",
  BtnContianerUnLock: "BtnContianerUnLock",
  ChangeBookingDetailStatus: "ChangeBookingDetailStatus",
  BtnContianerLock: "BtnContianerLock",
  EditContainer: "EditContainer",
  ViewWarehousingCreation: "ViewWarehousingCreation",
  ViewWarehousingSearch: "ViewWarehousingSearch",
  BtnReceiptFormDownload: "BtnReceiptFormDownload",
  BtnGETsDownload: "BtnGETsDownload",
  BtnBatchUpdate: "BtnBatchUpdate",
  ViewRFQSetting: "ViewRFQSetting",
  ViewUploadDocReport: "ViewUploadDocReport",
  ViewCustomsDeclarationReport: "ViewCustomsDeclarationReport",
  ViewFreightAnalysisReport: "ViewFreightAnalysisReport",
  ViewPaymentReportForDHL: "ViewPaymentReportForDHL",
  CreateRFQ: "CreateRFQ",
  BtnRFQApply: "BtnRFQApply",
  BtnRFQRecall: "BtnRFQRecall",
  BtnRFQDelete: "BtnRFQDelete",
  BtnRFQApproved: "BtnRFQApproved",
  BtnRFQInvalid: "BtnRFQInvalid",
  ViewTariffRateSetting: "ViewTariffRateSetting",
  ViewAirwaysExpenseSetting: "ViewAirwaysExpenseSetting",
  BatchUpdatedDeclarationBookingInfo: "BatchUpdatedDeclarationBookingInfo",
  ViewImportDeclaration: "ViewImportDeclaration",
  ViewExportDeclaration: "ViewExportDeclaration",
  BtnAirwaysExpenseApply: "BtnAirwaysExpenseApply",
  BtnAirwaysExpenseRecall: "BtnAirwaysExpenseRecall",
  BtnAirwaysExpenseDelete: "BtnAirwaysExpenseDelete",
  BtnAirwaysExpenseApproved: "BtnAirwaysExpenseApproved",
  BtnAirwaysExpenseInvalid: "BtnAirwaysExpenseInvalid",
  CreateAirwaysExpense: "CreateAirwaysExpense",
  ViewShipImportConfirmReport: "ViewShipImportConfirmReport",
  ViewShipImportConfirmReportForBooking: "ViewShipImportConfirmReportForBooking",
  ViewShipImportConfirmReportForWarehousing: "ViewShipImportConfirmReportForWarehousing",
  ViewPaymentErrorReport: "ViewPaymentErrorReport",
  ViewPaymentReport: "ViewPaymentReport",
  ViewAsnInfoSearch: "ViewAsnInfoSearch",
  ViewIQCStatusSearch: "ViewIQCStatusSearch",

  ViewNonGUICheck: "ViewNonGUICheck",
  EditNonGUICheck: "EditNonGUICheck",
  ViewGUICheck: "ViewGUICheck",
  EditGUICheck: "EditGUICheck",
  EditDetailGUICheck: "EditDetailGUICheck",
  ViewImportDeclarationFeeAccountingReport: "ViewImportDeclarationFeeAccountingReport",
  ViewImportDeclarationFeeReport: "ViewImportDeclarationFeeReport",
  ViewBilling: "ViewBilling",
  EditBilling: "EditBilling",
  CheckBilling: "CheckBilling",
  BillingDownload: "BillingDownload",
  BillingUpload: "BillingUpload",
  NonGovermentUniformInvoiceDownload: "NonGovermentUniformInvoiceDownload",
  NonGovermentUniformInvoiceUploadownload: "NonGovermentUniformInvoiceUploadownload",
  GovermentUniformInvoiceDownload: "GovermentUniformInvoiceDownload",
  GovermentUniformInvoiceDownloadPDF: "GovermentUniformInvoiceDownloadPDF",

  ViewDOAbnormal: "ViewDOAbnormal",
  DOAbnormalEdit: "DOAbnormalEdit",
  DOAbnormalUpload: "DOAbnormalUpload",
  DOAbnormalSendNotification: "DOAbnormalSendNotification",
  DOAbnormalReplyNotification: "DOAbnormalReplyNotification",

  ViewRequestExpenseReport: "ViewRequestExpenseReport",
  UpdateRmbPrice: "UpdateRmbPrice",
  DownloadRmbPriceReport: "DownloadRmbPriceReport",
  CreateDeclarationBooking: "CreateDeclarationBooking",
  ViewInOutWarehousingSearch: "ViewInOutWarehousingSearch",
  ViewMergeKeySearch: "ViewMergeKeySearch",
  BtnMergeKeyCSRWithdraw: "BtnMergeKeyCSRWithdraw",
  BtnMergeKeyCancelMergeKey: "BtnMergeKeyCancelMergeKey",
  BtnMergeKeyCancelDeliveryOrderMerge: "BtnMergeKeyCancelDeliveryOrderMerge",
  BtnMergeKeyUpdateMixFacilityByAdmin: "BtnMergeKeyUpdateMixFacilityByAdmin",

  ViewReceivingInstruction: "ViewReceivingInstruction",
  EditReceivingInstruction: "EditReceivingInstruction",
  ViewFacilityAnnouncement: "ViewFacilityAnnouncement",
  FacilityAnnouncementAdmin: "FacilityAnnouncementAdmin",
  ViewAdvisingAbnormal: "ViewAdvisingAbnormal",
  AdvisingAbnormalEdit: "AdvisingAbnormalEdit",
  AdvisingAbnormalUpload: "AdvisingAbnormalUpload",
  AdvisingAbnormalSendNotification: "AdvisingAbnormalSendNotification",
  AdvisingAbnormalReplyNotification: "AdvisingAbnormalReplyNotification",
  ViewLaaSCalender: "ViewLaaSCalender",
  EditLaaSCalender: "EditLaaSCalender",
  ViewQueryADStatus: "ViewQueryADStatus",
  ViewFaqMaintenance: "ViewFaqMaintenance",
  ViewFAQSearch: "ViewFAQSearch",
  ViewForwarderCooperation: "ViewForwarderCooperation",
  ViewCustomerChopSignSample: "ViewCustomerChopSignSample",

  BtnWarehousingPrint: "BtnWarehousingPrint",
  BtnWarehousingImportAD: "BtnWarehousingImportAD",
  BtnWarehousingImportDropshipment: "BtnWarehousingImportDropshipment",
  BtnBillingDisplay: "BtnBillingDisplay",
  BtnWarehousingAssign: "BtnWarehousingAssign",
  BtnWarehousingCopy: "BtnWarehousingCopy",
  BtnWarehousingUpload: "BtnWarehousingUpload",
  BtnWarehousingQuotation: "BtnWarehousingQuotation",
  BtnDeleteWarehousingDetail: "BtnDeleteWarehousingDetail",
  EditWarehousingFormExpressTerm: "EditWarehousingFormExpressTerm",
  EditBookingDetailSerialPda: "EditBookingDetailSerialPda",
  BtnExpenseView: "BtnExpenseView",
  BtnExpenseApply: "BtnExpenseApply",
  BtnApproveNonGUI: "BtnApproveNonGUI",
  EditRFQRemark: "EditRFQRemark",
  BtnApproveGUI: "BtnApproveGUI",
  ViewSubscription: "ViewSubscription",
  ViewFreightSearch: "ViewFreightSearch",
  CancelWarehousing: "CancelWarehousing",
  EditWarehousingRelatedBilling: "EditWarehousingRelatedBilling",
  EditBookingRelatedBilling: "EditBookingRelatedBilling",
  ViewUserGroupSubscription: "ViewUserGroupSubscription",
  EditUserGroupSubscription: "EditUserGroupSubscription",
  ViewAutoPrintSetting: "ViewAutoPrintSetting",
  EditAutoPrintSetting: "EditAutoPrintSetting",
  ViewTenantMappingUserGroupDetailDialog: "ViewTenantMappingUserGroupDetailDialog",
  EditFrontLineDocument: "EditFrontLineDocument",
  ViewIntransitUpdate: "ViewIntransitUpdate",
  BtnChangePickStatus: "BtnChangePickStatus",
  ViewRegistrationForm: "ViewRegistrationForm",
  ViewRegistrationFormSearch: "ViewRegistrationFormSearch",
  EditRegistrationForm: "EditRegistrationForm",
  BtnBillingViewerAddBilling: "BtnBillingViewerAddBilling",
  BtnBillingViewerDeleteBilling: "BtnBillingViewerDeleteBilling",
  ViewSearchPurchaseOrder: "ViewPoSearch",
  ConvertPoToAd: "ConvertPoToAd",
  ViewMaterialDocumentSearch: "ViewMaterialDocumentSearch",
  BtnWarehousingDetailAbnormal: "BtnWarehousingDetailAbnormal",
  ViewCreateDo: "ViewCreateDo",
  EditManualAllocation: "EditManualAllocation",
  ViewContainerPackingComboBtn: "ViewContainerPackingComboBtn",
  ViewDownloadContainerSignReceiptBtn: "ViewDownloadContainerSignReceiptBtn",
  ViewSendContainerBoxDetailExcelBtn: "ViewSendContainerBoxDetailExcelBtn",
  ViewDownloadUnBondedDocBtn: "ViewDownloadUnBondedDocBtn",
  ViewReturnTradeVanBtn: "ViewReturnTradeVanBtn",
  ViewWarehousingAbnormal: "ViewWarehousingAbnormal",
  ViewWarehousingAbnormalTrackingForShippingDialog:
    "ViewWarehousingAbnormalTrackingForShippingDialog",
  ViewWarehousingAbnormalHandlingForPcsrDialog:
    "ViewWarehousingAbnormalHandlingForPcsrDialog",
  ViewStockSKUSearch: "ViewStockSKUSearch",
  ViewEnvironmentMonitorComponent: "ViewEnvironmentMonitorComponent",
  ViewStockInfoSearch: "ViewStockInfoSearch",
  ViewCustomsClearanceShippingReport: "ViewCustomsClearanceShippingReport",
  ViewDailyRateSetting: "ViewDailyRateSetting",
  ViewManualAllocation: "ViewManualAllocation",
  ViewForwarderSetting: "ViewForwarderSetting",
  EditForwarderSetting: "EditForwarderSetting",
  ViewRole: "ViewRole",
  EditRole: "EditRole",
  BtnApplyFrontLineDocReturn: "BtnApplyFrontLineDocReturn",
  BtnReplyFrontLineDocReturn: "BtnReplyFrontLineDocReturn",
  ViewTruckCostAllocation: "ViewTruckCostAllocation",
  EditTruckCostAllocation: "EditTruckCostAllocation",
  ViewScheduleEffectiveTimeSetting: "ViewScheduleEffectiveTimeSetting",
  ViewAllocationConstraint: "ViewAllocationConstraint",
  AddAllocationConstraint: "AddAllocationConstraint",
  ViewAllocationConstraintInbound: "ViewAllocationConstraintInbound",
  AddAllocationConstraintInbound: "AddAllocationConstraintInbound",
  ViewSpecialInventoryControlComponent: "ViewSpecialInventoryControl",
  ViewPurgeControl: "ViewPurgeControl",
  BtnConfirmPurgeControl: "BtnConfirmPurgeControl",
  BtnResetPurgeControl: "BtnResetPurgeControl",
  ViewPlantTransfer: "ViewPlantTransfer",
  BtnPlantTransferExecuteNow: "BtnPlantTransferExecuteNow",
  BtnPlantTransferCompleteNow: "BtnPlantTransferCompleteNow",
  BtnPlantTransferCancelNow: "BtnPlantTransferCancelNow",
  BtnUrgentNoSetting: "BtnUrgentNoSetting",
  ViewExpiredControl: "ViewExpiredControl",
  ViewCustomsDeclarationComparisonReport: "ViewCustomsDeclarationComparisonReport",
  ViewCustomerLabelMaintenance: "ViewCustomerLabelMaintenance",
  EditCustomerLabelMaintenance: "EditCustomerLabelMaintenance",
  ManageInvUpload: "ManageInvUpload",

  HelpCenterView: "HelpCenterView",
  HelpUserArticleEdit: "HelpUserArticleEdit",
  HelpITArticleEdit: "HelpITArticleEdit",
  UserGuideDocEdit: "UserGuideDocEdit",
  HelpUserDocEdit: "HelpUserDocEdit",

  BookingFloorExBkSearch: "ViewBookingFloorExBkSearch",
  ChinaImportDeclarationReport: "ChinaImportDeclarationReport",
  ChinaImportDeclarationFeeReport: "ViewChinaImportDeclarationFeeReport",
  InOutReport: "ViewInOutReport",
  MESReport: "ViewMESReport",

  AreaMappingRFQMaintenance: "ViewAreaMappingRFQMaintenance",
  AirportMaintenance: "ViewAirportMaintenance",
  AssignmentDistrictMaintenance: "ViewAssignmentDistrictMaintenance",
  CarSequenceMaintenance: "ViewCarSequenceMaintenance",
  CityMaintenance: "ViewCityMaintenance",
  CusomterChopSign: "ViewCusomterChopSign",
  DHLCityMaintenance: "ViewDHLCityMaintenance",
  FacilityOptionMaintenance: "ViewFacilityOptionMaintenance",
  HubLabelSetup: "ViewHubLabelSetup",
  TermsMaintenance: "ViewTermsMaintenance",
  StockMaintenance: "ViewStockMaintenance",
  ImportExportLicenceInfo: "ViewImportExportLicenceInfo",
  AutoPrintReprint: "ViewAutoPrintReprint",
  BookingArrive: "ViewBookingArrive",
  Contianer: "ViewContianer",
  ExportDeclaration: "CreateExportDeclaration",
  FreightTrialCalculation: "ViewFreightTrialCalculation",
  MixCartonSearch: "ViewMixCartonSearch",
  MSDCIQC: "ViewMSDCIQC",
  MSDCSearch: "ViewMSDCSearch",
  OverDcSearch: "ViewOverDcSearch",
  VmiDOCreate: "ViewVmiDOCreate",
  VmiAdvising: "ViewVmiAdvising",

  // SCDG-HK 白名單功能：指派入倉單 facility 過濾用
  AssignWarehousing: "AssignWarehousing",
};

export type PermissionConstants =
  typeof PermissionConstants[keyof typeof PermissionConstants];
